import { render, staticRenderFns } from "./pageSix.vue?vue&type=template&id=1c5e9896&scoped=true"
import script from "./pageSix.vue?vue&type=script&lang=js"
export * from "./pageSix.vue?vue&type=script&lang=js"
import style0 from "../../../statistics/css/addProject.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./pageSix.vue?vue&type=style&index=1&id=1c5e9896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5e9896",
  null
  
)

export default component.exports